import slashIcon from "@common/assets/images/slash-icon-grey70.svg";
import { vars } from "@common/styles";
import styled, { css } from "styled-components";

export const Navigation = styled.nav`
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;

    li {
      position: relative;
      height: 4.4rem;

      &:not(:last-of-type) {
        padding-right: 3.6rem;

        &::after {
          content: "";
          display: flex;
          align-items: center;
          justify-content: center;
          width: 2.4rem;
          height: 2.4rem;
          margin: auto;
          background-image: url(${slashIcon});
          background-repeat: no-repeat;
          background-position: center;
          position: absolute;
          top: 0;
          right: 0.6rem;
          bottom: 0;
        }
      }
    }
  }
`;

export const NavItem = styled.li`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-width: 10rem;
  max-width: 38rem;
  user-select: none;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.4rem;
    height: 2.4rem;
    margin-right: 0.8rem;

    img {
      max-width: 100%;
      height: auto;
      transform: translateZ(0);
    }
  }
`;

export const NavItemInner = styled.div<{ $withClick?: boolean }>`
  height: 100%;
  display: flex;
  max-width: 36rem;
  align-items: center;
  border-radius: 1rem;
  margin-right: 0.8rem;

  > span {
    max-width: 21.5rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  
  > * {
    display: inline-block;
  }

  ${(props) =>
    props.$withClick &&
    css`
      border: 1px solid ${vars.colors.grey80}; /* Grey border */
      background-color: ${vars.colors.grey100};
      height: 4.6rem;
      cursor: pointer;

      &:hover {
        background-color: ${vars.colors.grey100};
      }
    `}

}
`;
